import { getTaskErrorMessage, getTaskStatusLabel } from "./constants";

import "./styles.scss";

const SandboxTaskStatusBadge = ({ task }) => {
  if (!task) return null;

  const errorMessage = getTaskErrorMessage(task);

  return (
    <span
      className={`sandbox-task-status sandbox-task-status--${task.status?.toLowerCase()}`}
      title={errorMessage || undefined}>
      {getTaskStatusLabel(task)}
    </span>
  );
};

export default SandboxTaskStatusBadge;
